(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recently-viewed"]) return;
  try {
      
function removeClassAtIndex(elements, index) {
  elements.forEach(data => {
    const classNameToRemove = data.classList.item(index);
    if (classNameToRemove) {
      data.classList.remove(classNameToRemove);
    }
  });
}

function fetchData() {
  setTimeout(() => {
    let removeclass = document.querySelectorAll('#RecentlyViewed-recently-viewed .grid__item .zoomywishid');
    const indexToRemove = 1;
    removeClassAtIndex(removeclass, indexToRemove);

    let addclass = document.querySelectorAll('#RecentlyViewed-recently-viewed .grid__item .zoomywishid')
    const handle = document.querySelectorAll('#RecentlyViewed-recently-viewed .grid-product__link');
    let addcls = 0;
    handle.forEach(item => {
      let SPL__ = item.getAttribute('href');
      let SPL_ = SPL__.split('?');
      item.setAttribute('href', SPL_[0]);

      setTimeout(() => {
        let SPL = item.getAttribute('href');
        $.getJSON(SPL + '.js', function(data) {
          console.log(data)
          item.parentElement.previousElementSibling.classList.add(`zoomywishid-${data.id}`)
          item.parentElement.previousElementSibling.setAttribute('data-product-id', data.id);
          item.parentElement.previousElementSibling.setAttribute('data-variant', data.variants[0].id);
          item.parentElement.previousElementSibling.setAttribute('data-handle', data.handle);
          item.parentElement.previousElementSibling.setAttribute('data-price', data.price / 100 + '.00');
          item.parentElement.previousElementSibling.setAttribute('data-image', data.featured_image);
          item.closest(".grid-product__content").setAttribute('data-product-id', data.id);
          item.closest(".grid-product__content").setAttribute('data-variant', data.variants[0].id);
        });
      }, 1000);
    });
  }, 1000);
}

function handleScroll() {
  fetchData();
  window.removeEventListener('scroll', handleScroll);
}

window.addEventListener('scroll', handleScroll);



  } catch(e) { console.error(e); }
})();
})();
